import { WidgetContentLanguageLabelModel } from './widget-content-language-label.model';
import { isDefined } from '@fi-shared/utils/is-defined';
import { isObject } from 'util';
import { WidgetType } from '@fi-shared/types/widget-type';
import { ContentLanguageLabelModel } from '@fi-shared/models';
import { WidgetTagOptionType } from '@fi-shared/types/widget-tag-option-type';
import { IWidgetSettingsModel } from '@fi-shared/widget/widget-settings.model';
import {
    IContentLanguage,
    IContentLanguageLabelModel,
} from '@fi-shared/fi-content-language-shared/fi-content-language-shared';
import { ModuleType } from '@fi-app/shared/types/module-type';

export interface IWidgetContentModel {
    Id?: number;
    WidgetId: number;
    WidgetType: WidgetType;
    SiteDesignId: number;
    Settings?: any; //todo typings
    ModuleType: ModuleType;
    Name?: string;
    WidgetSetting: any; //todo typings
    ParentSettings?: any; //todo typings
    TagIds?: number[];
    SortOrder: number;
    Names?: IContentLanguageLabelModel[];
}

export class WidgetContentModel {
    Id = 0;
    WidgetId = 0;
    WidgetType = 0;
    Settings: IWidgetSettingsModel = {
        HeaderNames: {},
    };
    ModuleType = 0;
    SortOrder = 0;
    ParentSettings = {};
    Name = '';
    Names: ContentLanguageLabelModel[] = [];
    TagIds: number[] = [];
    SiteDesignId: number;
    objectId;
    objectType;

    constructor(ContentLanguages: IContentLanguage[], initializeItem?: IWidgetContentModel) {
        if (initializeItem) {
            this.Initialize(initializeItem, ContentLanguages);
        }
    }

    Initialize(widget: IWidgetContentModel, ContentLanguages: IContentLanguage[]) {
        var _self = this;
        this.Id = widget.Id | 0;
        this.WidgetId = widget.WidgetId;
        this.WidgetType = widget.WidgetType;
        this.SiteDesignId = widget.SiteDesignId;

        if (widget.Settings) {
            try {
                this.Settings = isObject(widget.Settings)
                    ? Object.assign({}, widget.Settings)
                    : JSON.parse(widget.Settings);

                // default settings
                if (!isDefined(this.Settings.DisplayContainer)) {
                    this.Settings.DisplayContainer = true;
                }

                if (!isDefined(this.Settings.DisplayHeader)) {
                    this.Settings.DisplayHeader = true;
                }

                if (!isDefined(this.Settings.ShowInApp) && isShowInAppAvailable(this.WidgetId)) {
                    this.Settings.ShowInApp = true;
                }
            } catch (exception) {
                this.Settings = {};
            }

            if (this.Settings.WidgetTagOptionType === 0)
                this.Settings.WidgetTagOptionType = WidgetTagOptionType.AnySelected;

            if (!this.Settings.NumberOfRecordsToTake) this.Settings.NumberOfRecordsToTake = 20;
        }

        this.ModuleType = widget.ModuleType;
        this.Name = widget.Name;
        this.SortOrder = widget.SortOrder;
        this.TagIds = widget.TagIds || [];

        if (widget.WidgetSetting || widget.ParentSettings) {
            try {
                this.ParentSettings = isObject(widget.WidgetSetting || widget.ParentSettings)
                    ? Object.assign({}, widget.WidgetSetting || widget.ParentSettings)
                    : JSON.parse(widget.WidgetSetting);
            } catch (exception) {
                this.ParentSettings = {};
            }
        }

        if (isDefined(_self.Settings.HeaderNames)) {
            this.Names.length = 0;
            for (let key in _self.Settings.HeaderNames) {
                let name = _self.Settings.HeaderNames[key];
                const contentLang = ContentLanguages.find((contentLang: IContentLanguage) => {
                    return contentLang.Id == parseInt(key);
                });
                if (contentLang) {
                    _self.Names.push(new ContentLanguageLabelModel(key, name, contentLang.SortIndex));
                }
            }
        } else if (widget.Names) {
            this.Names = widget.Names;
            this.Settings.HeaderNames = {};
            widget.Names.forEach(function (name) {
                _self.Settings.HeaderNames[name.ContentLanguageId] = name.Value;
            });
        }
    }

    InitializeWidgetContentLanguageLabels(languages) {
        languages.forEach((language) => {
            var exists =
                this.Names.filter(function (item) {
                    return item.ContentLanguageId == language.Id;
                }).length > 0;

            if (!exists) {
                var contentLanguageLabelItem = new WidgetContentLanguageLabelModel();
                contentLanguageLabelItem.InitializeFromLanguageItem(language, this.WidgetId);
                this.Names.push(contentLanguageLabelItem);
            }
        });
    }
}

const mobileWidgets = [
    WidgetType.DocumentListing,
    WidgetType.SiteMap,
    WidgetType.ForumListing,
    WidgetType.AdvancedText,
];

function isShowInAppAvailable(widgetId) {
    return mobileWidgets.indexOf(widgetId) > -1;
}
